module.exports = __webpack_public_path__ + "img/Simplex1.43a930be.png";